function controls(menuName, menus) {
  let menuId = 0;
  menus.map((c) => {
    if (c.type == 'menucontrol') {
      if (c.menu == menuName) {
        menuId = c.id;
      }
    }
  })
  let view = 0; let add = 0; let edit = 0; let cancel = 0; let exports = 0;
  menus.map((c) => {
    if (c.type == "submenucontrol") {
      if (c.id == menuId) {
        if (c.menu == 'view') { view = c.edit; }
        if (c.menu == 'add') { add = c.edit; }
        if (c.menu == 'edit') { edit = c.edit; }
        if (c.menu == 'cancel') { cancel = c.edit; }
        if (c.menu == 'exports') { exports = c.edit; }
      }
    }
  })
  if (view == 0 || view == '0') { view = false; } else { view = true; }
  if (edit == 0 || edit == '0') { edit = false; } else { edit = true; }
  if (cancel == 0 || cancel == '0') { cancel = false; } else { cancel = true; }
  if (exports == 0 || exports == '0') { exports = false; } else { exports = true; }
  if (add == 0 || add == '0') { add = false; } else { add = true; }
  return { view, edit, cancel, exports, add };
}
  
export default controls;
  